import { render, staticRenderFns } from "./ModalNews.vue?vue&type=template&id=d17c2504&scoped=true"
import script from "./ModalNews.vue?vue&type=script&lang=js"
export * from "./ModalNews.vue?vue&type=script&lang=js"
import style0 from "./ModalNews.vue?vue&type=style&index=0&id=d17c2504&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17c2504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d17c2504')) {
      api.createRecord('d17c2504', component.options)
    } else {
      api.reload('d17c2504', component.options)
    }
    module.hot.accept("./ModalNews.vue?vue&type=template&id=d17c2504&scoped=true", function () {
      api.rerender('d17c2504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/ModalNews.vue"
export default component.exports